import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'activityAssignPreference.components.pageTitle',
        defaultMessage: 'Preferences'
    },
    pageSubHeading: {
        id: 'activityAssignPreference.components.pageSubHeading',
        defaultMessage: 'Due dates for activity assign'
    },
    noDuedate: {
        id: 'activityAssignPreference.components.noDuedate',
        defaultMessage: 'No Due Date'
    },
    due: {
        id: 'activityAssignPreference.components.due',
        defaultMessage: 'Start date'
    },
    notification: {
        id: 'activityAssignPreference.components.notification',
        defaultMessage: 'Due date'
    },
    option: {
        id: 'activityAssignPreference.components.option',
        defaultMessage: 'Please select'
    },
    save: {
        id: 'activityAssignPreference.components.save',
        defaultMessage: 'Save'
    },
    cancel: {
        id: 'activityAssignPreference.components.cancel',
        defaultMessage: 'Cancel'
    },
    reset: {
        id: 'activityAssignPreference.components.reset',
        defaultMessage: 'Reset'
    }
});



// WEBPACK FOOTER //
// ./app/components/activity-assign-preference/messages.js